<template>
  <v-container justify-center>
      <v-layout justify-center>
          <v-flex xs12 lg6>
              <v-btn color="#407fc2" x-large rounded to="/" class="margin-top" block>Back to Homepage</v-btn>
          </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'BackHome',
  data: () => ({
    
  }),
};
</script>
